<template>
  <div class="slotMachine mt-5">
    <div class="d-flex flex-wrap slot-container">
      <div
        class="slot"
        v-for="(slot, index) in slots"
        ref="slotsRef"
        v-bind:key="index"
      >
        <h2 class="pb-4">{{ slot.digits }}</h2>
        <!-- <h2>{{ slots[index].userId }}</h2> -->
        <v-card class="slot__window d-flex justify-center">
          <div
            v-if="spinning || gifted_kado.length !== 0"
            class="slot__wrap text-color"
          >
            <div
              class="slot__item no-kado"
              v-for="(opt, idx) in randomIndex"
              v-bind:key="idx"
            >
              {{ opt }}
            </div>
            <div class="slot__item slot__item--copy">{{ list_kado[0] }}</div>
          </div>
          <div v-else class="slot__wrap text-color">
            <div
              class="slot__item no-kado"
              v-for="(opt, idx) in list_kado"
              v-bind:key="idx"
            >
              ?
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { useSound } from "@vueuse/sound";
import slotSfx from "../../assets/slot-sound.mp3";

const next =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  function (cb) {
    window.setTimeout(cb, 1000 / 60);
  };

export default {
  data() {
    return {
      spinning: false,
      gifted_kado: [],
      arrUserId: [],
      randomIndex: [],
      num: 0,
      opts: null,
      startedAt: null,
    };
  },
  setup() {
    const slotSound = useSound(slotSfx, { volume: 0.5 });
    return {
      slotSound,
    };
  },
  computed: {
    ...mapState({
      slots: (state) => state.slotMachine.slots,
      list_kado: (state) => state.slotMachine.list_kado,
    }),
  },
  watch: {},
  methods: {
    start: function () {
      if (this.opts) {
        return;
      }
      this.spinning = true;
      let tempKado = this.list_kado;

      function randomNumber(data) {
        return Math.floor(Math.random() * data.length);
      }

      for (let idx = 0; idx < this.slots.length; idx++) {
        var r = randomNumber(tempKado);

        if (tempKado[r] === this.slots[idx].noKado) {
          while (tempKado[r] === this.slots[idx].noKado) {
            r = randomNumber(tempKado);
            // console.log("GET RANDOM");
          }

          this.slots[idx].getKado = tempKado[r];
          this.randomIndex.push(tempKado[r]);
        } else {
          this.slots[idx].getKado = tempKado[r];
          this.randomIndex.push(tempKado[r]);
        }
        tempKado.splice(r, 1);
      }

      this.opts = this.slots.map((data, i) => {
        const slot = this.$refs.slotsRef[i];
        this.num = i;

        slot.querySelector(".text-color").style.color = "#6200ea";

        const opts = {
          el: slot.querySelector(".slot__wrap"),
          finalPos: i * 80,
          startOffset: 2000 + Math.random() * 500 + i * 500,
          height: this.randomIndex.length * 120,
          duration: 500 + i * 500, // milliseconds
          isFinished: false,
        };
        //  BELOW USERID NEED TO CHANGE WITH data.userId
        if (data.noKado === this.randomIndex[i])
          console.log("ADA YG SAMA", {
            userId: data.userId,
            noKado: this.randomIndex[i],
          });
        this.gifted_kado.push({
          userId: data.userId,
          noKado: this.randomIndex[i],
        });
        this.arrUserId.push(data.userId);
        // update di db status kado pemilik telah diberikan
        return opts;
      });

      next(this.animate);
    },

    animate: function (timestamp) {
      if (this.startedAt == null) {
        this.startedAt = timestamp;
      }

      const timeDiff = timestamp - this.startedAt;

      this.opts.forEach((opt) => {
        if (opt.isFinished) {
          return;
        }

        const timeRemaining = Math.max(opt.duration - timeDiff, 0);
        const power = 3;
        const offset =
          (Math.pow(timeRemaining, power) / Math.pow(opt.duration, power)) *
          opt.startOffset;

        // negative, such that slots move from top to bottom
        const pos = -1 * Math.floor((offset + opt.finalPos) % opt.height);

        opt.el.style.transform = "translateY(" + pos + "px)";

        if (timeDiff > opt.duration) {
          // console.log('finished', opt, pos, opt.finalPost)
          opt.isFinished = true;
        }
      });

      if (this.opts.every((o) => o.isFinished)) {
        this.opts = null;
        this.startedAt = null;
        this.spinning = false;
        if (!this.spinning) {
          // console.log(
          //   {
          //     data: this.gifted_kado,
          //     userId: this.arrUserId,
          //   },
          //   "masuk sini ======================"
          // );

          this.$store.dispatch("updateDataKado", {
            data: this.gifted_kado,
            userId: this.arrUserId,
          });
        }
        // this.gifted_kado = []
      } else {
        next(this.animate);
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap");

.slot {
  margin: 10px 12px;
}

.slot__window {
  background-color: rgb(104, 155, 104);
  width: 100px;
  height: 100px;
  overflow: hidden;
}

.slot__wrap {
}

.slot__item {
  margin-top: 20px;
  height: 60px;
  width: 100px;
  padding: 0 10px;

  font-family: "Press Start 2P", cursive;
  font-size: 32px;
  text-align: center;

  line-height: 60px;
}

.slot__item--copy {
}

.slot-container {
  margin: auto 12px;
  justify-content: center;
}
.no-kado {
}
</style>
